export function normalizeLanguageCode(language?: string): 'pl' | 'en' {
  return String(language || 'pl').toLowerCase().startsWith('en') ? 'en' : 'pl';
}

export function localeForLanguage(language?: string): string {
  return normalizeLanguageCode(language) === 'en' ? 'en-US' : 'pl-PL';
}

export function formatLocalizedNumber(
  value: number | null | undefined,
  fractionDigits: number,
  language?: string,
): string {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

  return safeValue.toLocaleString(localeForLanguage(language), {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatLocalizedPercent(
  value: number | null | undefined,
  language?: string,
  fractionDigits = 1,
): string {
  return `${formatLocalizedNumber(value, fractionDigits, language)}%`;
}

/** Compact physical/commercial quantity: localized, with no artificial trailing zeros. */
export function formatLocalizedQuantity(
  value: number | null | undefined,
  language?: string,
): string {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
  return safeValue.toLocaleString(localeForLanguage(language), {
    maximumFractionDigits: 3,
  });
}
